import * as TYPE from '../util/types'

const state = {
	alert_text: 'This is an alert',
	alert_active: false,
	alert_link_route: '/dashboard'
}

const mutations = {
	[TYPE.SET_ALERT_TEXT]: (state, value) => {
		state.alert_text = value
	},
	[TYPE.SET_ALERT_ACTIVE]: (state, value) => {
		state.alert_active = value
	},
	[TYPE.SET_ALERT_LINK_ROUTE]: (state, value) => {
		state.alert_link_route = value
	}
}

const actions = {
	setAlertActive({ commit }, value) {
		commit(TYPE.SET_ALERT_ACTIVE, value)
	},
	setAlertLinkRoute({ commit }, value) {
		commit(TYPE.SET_ALERT_LINK_ROUTE, value)
	}
}

const getters = {
	getAlertText: state => {
		return state.alert_text
	},
	getAlertActive: state => {
		return state.alert_active
	},
	getAlertLinkRoute: state => {
		return state.alert_link_route
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
